<footer>
    <div class="row">
        <div class="left-side">
            <span>&copy; {{ currentYear }} New Wave Schools</span>
        </div>

        <div class="right-side">
            <a [routerLink]="homeRoute()" data-test="shell-footer-home">
                {{ 'footer.home' | translate }}
            </a>

            <a [href]="'https://newwaveschools.com/privacy-policy/'" target="_blank" data-test="shell-footer-privacy">
                {{ 'footer.privacy-policy' | translate }}
            </a>

            <a href="/" target="_blank" data-test="shell-footer-contact">
                {{ 'footer.contact' | translate }}
            </a>
        </div>
    </div>

    @if (buildTime) {
        <div class="version">v{{ buildTime }}</div>
    }
</footer>
